import { jsx } from "react/jsx-runtime";
import cx from "classnames";
const ValidationBorder = (props) => {
  const {
    prefix = "",
    disabled,
    readOnly,
    shouldValidate,
    className,
    valid
  } = props;
  const borderBaseClass = `${prefix}validation-border`;
  const borderClasses = cx(
    `${borderBaseClass}`,
    shouldValidate && `${borderBaseClass}--${valid}`,
    disabled && `${borderBaseClass}--disabled`,
    readOnly && `${borderBaseClass}--read-only`,
    className
  );
  return /* @__PURE__ */ jsx("span", { className: borderClasses });
};
ValidationBorder.displayName = "ValidationBorder";
var ValidationBorder_default = ValidationBorder;
export {
  ValidationBorder_default as default
};
